import { tt } from '../i18n';
import { useKeyboard } from './useKeyboard';
import { useState } from 'react';
import { formatMoney } from '@dastarhan/core';

const PRESETS = [5, 10, 15] as const;

/** Скидка на чек: процент-пресеты или сумма. Хранится суммой в тиынах —
 *  если после скидки в чек добавили блюдо, сумма скидки не «плывёт». */
export function DiscountDialog({ subtotal, current, limitPct, onApply, onCancel }: {
  subtotal: number;
  current: number;
  /** потолок роли в %; null — без лимита. Сверх — PIN старшего. */
  limitPct: number | null;
  onApply: (amount: number) => void;
  onCancel: () => void;
}) {
  const [raw, setRaw] = useState(current > 0 ? String(current / 100) : '');
  // Суммы на планшете набирают своей клавиатурой: системная
  // либо не всплывает, либо закрывает половину экрана
  const kb = useKeyboard(raw, setRaw, 'number');
  const amount = Math.round(Number(raw.replace(',', '.')) * 100) || 0;
  const valid = amount > 0 && amount <= subtotal;

  return (
    <div className="dialog-backdrop" role="dialog" aria-modal="true" aria-label="Скидка">
      <div className="dialog">
        {limitPct !== null && (
          <p className="hint" style={{ margin: 0, order: 2 }}>
            Ваш лимит — {limitPct}% ({formatMoney(Math.round((subtotal * limitPct) / 100))}).
            Сверх — подтвердит старший.
          </p>
        )}
        <span className="eyebrow">{tt('discountTitle')}</span>
        <h1>Подытог: {formatMoney(subtotal)}</h1>
        <div className="quick" style={{ width: 280 }}>
          {PRESETS.map((p) => {
            const v = Math.round((subtotal * p) / 100);
            return (
              <button key={p} className={`btn ${amount === v ? 'accent' : ''}`}
                onClick={() => setRaw(String(v / 100))}>
                {p}%
              </button>
            );
          })}
          <button className={`btn ${raw === '' ? '' : ''}`} onClick={() => setRaw('')}>Сбросить</button>
        </div>
        <input className="field" inputMode="decimal" placeholder="Сумма скидки, ₸"
          {...kb.props}
          value={raw} onChange={(e) => setRaw(e.target.value)} />
        {amount > subtotal && <p className="error">{tt('tooBig')}</p>}
        <div className="mod-actions">
          {current > 0 && (
            <button className="btn" onClick={() => onApply(0)}>{tt('removeDiscount')}</button>
          )}
          <button className="btn ghost" onClick={onCancel}>Отмена</button>
          <button className="btn accent" disabled={!valid} onClick={() => onApply(amount)}>
            Применить −{formatMoney(amount)}
          </button>
        </div>
      </div>
      {kb.node}
    </div>
  );
}
